import {Component, Input} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'admin-submenu',
  template: `
    <nav class="nav justify-content-end subnav dandp-submenu">
      <a class="nav-link" routerLink="users" routerLinkActive="active" role="button">Users</a>
      <a *ngIf="isSuperUser" class="nav-link" routerLink="lists" routerLinkActive="active" role="button">Lists</a>
    </nav>
  `,
  styles: []
})
export class AdminSubmenuComponent {
  @Input() isSuperUser: boolean;
  public onDashboard = false;
  constructor(private router: Router) {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        if (e.url.substr(1) === 'admin') {
          this.onDashboard = true;
        } else {
          this.onDashboard = false;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/admin-submenu.ts